<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="임시 비밀번호 발급" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 display-1 mt-5 text-left">비밀번호 변경</span>
                                <v-text-field label="현재 비밀번호 입력" outlined dense hint="현재 비밀번호 입력해주세요" class="mt-2 col-4" v-model="oldPassword" type="password"></v-text-field>
                            </v-row>
                            <v-row>
                                <v-text-field label="변경 비밀번호 입력" outlined dense hint="변경할 비밀번호 입력해주세요" class="mt-2 col-4" v-model="newPassword2" type="password"></v-text-field>
                            </v-row>
                            <v-row>
                                <v-text-field label="변경 비밀번호 재입력" outlined dense hint="변경할 비밀번호 다시 입력해주세요" class="mt-2 col-4" v-model="newPassword" type="password"></v-text-field>
                                <v-btn class="ml-2 mt-2 blue darken-2 text-white" v-on:click="updatePassword">변경</v-btn>
                                <span v-if="errMsg" class="col-12 mt-5 text-left caption red--text">{{errMsg}}</span>
                            </v-row>

                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'
//import Banner from '../components/Banner.vue'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 11,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,

            drawer: false,
            group: null,

            
            oldPassword: '',
            newPassword: '',
            newPassword2: '',
            errMsg: null,

        }
    },
    computed:{
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        updatePassword(){
            if(this.newPassword2.length < 8){
                this.errMsg = '비밀번호는 8자 이상을 입력해주세요.'
            } else if(this.newPassword != this.newPassword2){
                this.errMsg = '새로운 비밀번호가 일치하지 않습니다.'
            }
            else{
                this.$http.post('/api/users/rePassword', {
                        headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                        oldPassword: this.oldPassword,
                        newPassword: this.newPassword
                    })
                    .then(response => {
                        if (response.data.status == 200) {
                            alert('비밀번호 변경 완료. 다시 로그인 해주세요.')
                            this.$store.dispatch('postLogout')
                        } else {
                            this.errMsg = '이전 비밀번호가 올바르지 않습니다.'
                        }
                    })
                    .catch(error => {
                        console.log('register failed', error)
                    })
            }
        },
        goLogin(){
            window.location.href = '/login'
        }
    }
}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// src/pages/MyPage.vue